import { inject, InjectionToken, Provider } from '@angular/core';

export interface PreviewConfiguration {
	pdfAuthorization?: string | boolean | null | (() => string | boolean | null);
	customHeaders?: Record<string, string | undefined>;
}

export const defaultPreviewConfiguration: PreviewConfiguration = {
	pdfAuthorization: true,
	customHeaders: {},
};

export const PREVIEW_CONFIGURATION = new InjectionToken<PreviewConfiguration>(
	'PREVIEW_CONFIGURATION',
	{
		factory: () => defaultPreviewConfiguration,
	}
);

export const providePreviewConfiguration = (config: Partial<PreviewConfiguration>): Provider => {
	return {
		provide: PREVIEW_CONFIGURATION,
		useValue: {
			...defaultPreviewConfiguration,
			...config,
		},
	};
};

export const injectPreviewConfiguration = (): PreviewConfiguration => {
	return inject(PREVIEW_CONFIGURATION, { optional: true }) || defaultPreviewConfiguration;
};
